import { render } from "./LocationCard.vue?vue&type=template&id=51d069a0&scoped=true&ts=true"
import script from "./LocationCard.vue?vue&type=script&lang=ts"
export * from "./LocationCard.vue?vue&type=script&lang=ts"

import "./LocationCard.vue?vue&type=style&index=0&id=51d069a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d069a0"]])

export default __exports__